import { createReducer } from "@reduxjs/toolkit";
import { setSubscriptionPrices } from "store/actions/subscriptionPricesData";
import {
  setBankCards,
  setCompaniesList,
  setCompanyData,
  setGlobalLoading,
  setRouterUserRequestInProgress,
  setSalsa,
  setUserMetaData,
  setUserRewardPoints,
  setWorkerKycOnboardingInProgress,
  updateUserMetaDataLastActiveRole,
} from "store/actions/userMetaData";

import {
  BankCardResDto,
  CompanyResponseDto,
  GetSubscriptionPriceResponseDto,
  ListUserCompaniesResDto,
  UserRewardPointsResDto,
} from "utils/swagger_react_query";

import { MetaDataState } from "../types";

const initialState: MetaDataState = {
  userData: undefined,
  companyData: null,
  companiesList: null,
  globalLoading: false,
  bankCards: null,
  salsaData: {
    salsa: null,
    authToken: null,
  },
  workerKycOnboardingInProgress: false,
  routerUserRequestInProgress: false,
  rewardPointsData: null,
  subscriptionPrices: null,
};

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUserMetaData, (state, action) => {
      state.userData = action.payload;
    })
    .addCase(updateUserMetaDataLastActiveRole, (state, action) => {
      if (state.userData?.activeCompanyUser)
        state.userData = {
          ...state.userData,
          activeCompanyUser: {
            ...state.userData?.activeCompanyUser,
            lastActiveRole: action.payload,
          },
        };
    })
    .addCase(setCompanyData, (state, action) => {
      state.companyData = action.payload as CompanyResponseDto;
    })
    .addCase(setCompaniesList, (state, action) => {
      state.companiesList = action.payload as ListUserCompaniesResDto;
    })
    .addCase(setGlobalLoading, (state, action) => {
      state.globalLoading = action.payload as boolean;
    })
    .addCase(setBankCards, (state, action) => {
      state.bankCards = action.payload as BankCardResDto[];
    })
    .addCase(setSalsa, (state, action) => {
      state.salsaData = action.payload;
    })
    .addCase(setWorkerKycOnboardingInProgress, (state, action) => {
      state.workerKycOnboardingInProgress = action.payload as boolean;
    })
    .addCase(setRouterUserRequestInProgress, (state, action) => {
      state.routerUserRequestInProgress = action.payload as boolean;
    })
    .addCase(setUserRewardPoints, (state, action) => {
      state.rewardPointsData = action.payload as UserRewardPointsResDto;
    })
    .addCase(setSubscriptionPrices, (state, action) => {
      state.subscriptionPrices = action.payload as GetSubscriptionPriceResponseDto;
    });
});

export default reducer;
